export default "__VITE_ASSET__DHA7wmvb__"